import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";
import useUser from "@/users/useUser";
import stringifyParams from "@/utils/stringifyParams";

const useReadingLevelGet = (queryParams = {}, skip = false) => {
  const { data: user } = useUser();
  const userUniqueId = user?.unique_id;
  const params = { user_id: userUniqueId, ...queryParams };
  const resource = `${MONOLITH_ORIGIN}/api/v3/reading-level/${stringifyParams(params)}`;

  return useRestQuery(resource, { skip });
};

export default useReadingLevelGet;
